const DEVICE_KEY = 'vb_device_id';

export function getDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function resetDeviceTrust() {
  try {
    localStorage.removeItem(DEVICE_KEY);
  } catch {
    /* ignore */
  }
}

function hashString(input) {
  let h = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}

export function getDeviceFingerprint() {
  try {
    const parts = [
      navigator.userAgent || '',
      navigator.platform || '',
      navigator.language || '',
      Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      `${window.screen?.width || 0}x${window.screen?.height || 0}@${window.devicePixelRatio || 1}`,
      String(navigator.hardwareConcurrency || 0),
      String(navigator.maxTouchPoints || 0),
      navigator.vendor || '',
    ];
    return hashString(parts.join('::'));
  } catch {
    return null;
  }
}

export function getDeviceMeta() {
  const deviceId = getDeviceId();
  let userAgent = null;
  let platform = null;
  let screenInfo = null;
  let fingerprint = null;
  try {
    userAgent = navigator.userAgent || null;
    platform = [navigator.platform || '', navigator.language || ''].filter(Boolean).join(' · ') || null;
    screenInfo = `${window.screen?.width || 0}x${window.screen?.height || 0}@${window.devicePixelRatio || 1}`;
    fingerprint = getDeviceFingerprint();
  } catch {
    /* ignore */
  }
  return { deviceId, fingerprint, userAgent, platform, screenInfo };
}
